import { Link } from "react-router-dom";
import { Phone, MapPin, Mail, ArrowUp, Facebook, Instagram } from "lucide-react";

const pages = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Gallery", to: "/gallery" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
  { label: "Request a Quote", to: "/quote" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1a1d20] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 lg:py-16">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-10">
          {/* Brand */}
          <div className="max-w-xs">
            <div className="inline-block bg-white px-4 py-3">
              <img src="/logo.png" alt="SAMI FAB aluminium fabrication logo" className="h-11 w-auto" />
            </div>
            <p className="mt-5 text-slate-400 text-sm leading-relaxed">
              Aluminium welding & fabrication — proudly Albany, built for the Great Southern.
            </p>
          </div>

          {/* Pages */}
          <nav className="flex flex-wrap gap-x-8 gap-y-3" data-testid="footer-pages">
            {pages.map((p) => (
              <Link
                key={p.to}
                to={p.to}
                data-testid={`footer-link-${p.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="font-mono text-xs font-bold uppercase tracking-[0.18em] text-slate-300 hover:text-[#007bff] transition-colors duration-200"
              >
                {p.label}
              </Link>
            ))}
          </nav>

          {/* Contact */}
          <div className="space-y-3.5">
            <a
              href="tel:0415464900"
              data-testid="footer-phone-link"
              className="flex items-center gap-3 font-display font-black text-lg hover:text-[#007bff] transition-colors duration-200"
            >
              <Phone size={17} className="text-[#007bff] shrink-0" /> 0415 464 900
            </a>
            <a
              href="mailto:samiotismf@gmail.com"
              data-testid="footer-email-link"
              className="flex items-center gap-3 text-sm text-slate-300 hover:text-[#007bff] transition-colors duration-200"
            >
              <Mail size={15} className="text-[#007bff] shrink-0" /> samiotismf@gmail.com
            </a>
            <p className="flex items-center gap-3 text-sm text-slate-300">
              <MapPin size={15} className="text-[#007bff] shrink-0" /> Albany WA — Great Southern
            </p>
            <div className="flex gap-3 pt-1">
              <a
                href="https://www.facebook.com/share/1FPbwHzncB/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook-link"
                aria-label="Sami Fab on Facebook"
                className="w-10 h-10 border border-white/20 flex items-center justify-center text-slate-300 hover:bg-[#007bff] hover:border-[#007bff] hover:text-white transition-colors duration-200"
              >
                <Facebook size={17} />
              </a>
              <a
                href="https://www.instagram.com/samiotis.fab"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                aria-label="Sami Fab on Instagram"
                className="w-10 h-10 border border-white/20 flex items-center justify-center text-slate-300 hover:bg-[#007bff] hover:border-[#007bff] hover:text-white transition-colors duration-200"
              >
                <Instagram size={17} />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-wrap items-center justify-between gap-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
            © {new Date().getFullYear()} Sami Fab · Albany WA
          </p>
          <a
            href="https://www.layerly.com.au"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-made-by-layerly"
            className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 hover:text-[#007bff] transition-colors duration-200"
          >
            Made by Layerly
          </a>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            data-testid="footer-back-to-top"
            className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 hover:text-white transition-colors duration-200"
          >
            Back to top <ArrowUp size={14} />
          </button>
        </div>
      </div>
    </footer>
  );
}
